import React from 'react'

const BackArrow = props => (
  <svg
    width='20'
    height='14'
    viewBox='0 0 20 14'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    {...props}>
    <defs>
      <path
        d='M5.104 12.875H21.09c.502 0 .909-.392.909-.875s-.407-.875-.91-.875H5.105l4.812-4.631a.852.852 0 0 0 0-1.238.934.934 0 0 0-1.286 0l-6.364 6.125a.852.852 0 0 0 0 1.238l6.364 6.125a.934.934 0 0 0 1.286 0 .852.852 0 0 0 0-1.238l-4.812-4.631z'
        id='backArrowA'
      />
    </defs>
    <g transform='translate(-2 -5)' fill='none' fillRule='evenodd'>
      <path d='M0 0h24v24H0z' />
      <mask id='backArrowB' fill='#fff'>
        <use xlinkHref='#backArrowA' />
      </mask>
      <path d='M0 0h100v40H0z' mask='url(#backArrowB)' fill='#2D3030' />
    </g>
  </svg>
)

export default BackArrow



// WEBPACK FOOTER //
// ./src/svg-icons/BackArrow.js